import { Component } from '@angular/core';
import { HelpContentComponent, HelpContentRendererValue } from '../../UI-Lib/Help-Tooltip';

export type StampTooltipComponentParams = HelpContentRendererValue<any>;

@Component({
    selector: 'stamp-tooltip',
    template: `
        @if (data.activatedDateTime > data.inactivatedDateTime) {
          <div>
            @if (data.activatedBy) {
              <div>
                Activated by {{data.activatedBy}} <br>
                Date: {{data.activatedDateTime | date:'M/d/yyyy'}}
              </div>
            }
            @if (data.inactivatedBy || data.inactivatedDateTime) {
              <div style="margin-top: 10px;">
                Inactivated @if (data.inactivatedBy) {
                <span>by {{data.inactivatedBy}}</span>
                } <br>
                Date: {{data.inactivatedDateTime | date:'M/d/yyyy'}}
              </div>
            }
          </div>
        }
        @if (data.activatedDateTime <= data.inactivatedDateTime) {
          <div>
            @if (data.inactivatedBy || data.inactivatedDateTime) {
              <div style="margin-top: 10px;">
                Inactivated @if (data.inactivatedBy) {
                <span>by {{data.inactivatedBy}}</span>
                } <br>
                Date: {{data.inactivatedDateTime | date:'M/d/yyyy'}}
              </div>
            }
            @if (data.activatedBy) {
              <div>
                Activated by {{data.activatedBy}} <br>
                Date: {{data.activatedDateTime | date:'M/d/yyyy'}}
              </div>
            }
          </div>
        }
        `,
    standalone: false
})
export class StampTooltipComponent implements HelpContentComponent<StampTooltipComponentParams> {

    params: StampTooltipComponentParams;
    data: any;

    helpInit(params: StampTooltipComponentParams) {
        this.data = params.value;
    }
}
